export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12200.0fb6acb9.jpg";